import { apiUrl } from 'utils/envUtil';
import { APIRequest, AxiosInstance } from '../apiUtil';

/**
 * Request account deletion
 * - If team owner: deletes entire team
 * - If team member: deletes only their account
 */
export const requestAccountDeletion = (): Promise<any> => {
    return APIRequest({
        method: 'post',
        url: apiUrl + 'me/request-deletion',
        useDefaultErrorNotif: true,
    });
};

/**
 * Cancel a pending account deletion request
 */
export const cancelAccountDeletion = (): Promise<any> => {
    return APIRequest({
        method: 'post',
        url: apiUrl + 'me/cancel-deletion',
        useDefaultErrorNotif: true,
    });
};

/**
 * Get current account deletion status
 */
export const getAccountDeletionStatus = (): Promise<any> => {
    return APIRequest({
        method: 'get',
        url: apiUrl + 'me/deletion-status',
        useDefaultErrorNotif: true,
    });
};
